var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceFemaleInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 22.5c0 7.11-3.298 13.45-8.447 17.574-4.616 2.083-8.737.426-14.053.426-5.316 0-9.82 1.056-14.052-.426C3.298 35.95 0 29.61 0 22.5 0 10.073 10.073 0 22.5 0 34.926 0 45 10.073 45 22.5z",
    fill: "#E5E7EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.516 35.385l-2.183-1.22a9.011 9.011 0 01-3.964-4.505 10.75 10.75 0 001.156-1.578 28.421 28.421 0 004.484-1.429c-1.208-1.473-1.627-2.423-1.037-6.851.665-6.335-3.774-9.643-8.472-9.78-4.699.137-9.138 3.445-8.472 9.78.59 4.428.17 5.378-1.037 6.852 1.51.62 3.004 1.091 4.483 1.428.346.57.734 1.104 1.157 1.578a9.014 9.014 0 01-3.965 4.506l-2.182 1.219a9.01 9.01 0 00-4.033 4.684 22.4 22.4 0 0014.049 4.93 22.399 22.399 0 0014.049-4.931 9.011 9.011 0 00-4.033-4.683z",
    fill: "#9EA5AD"
  })));
}
export default SvgVoiceFemaleInactive;